import type { ImportantKpiEntry } from '@app/src/pages/Configurations/ConfigurationsPages/Automation/CreationSteps/HighlightImportantKpis/types'
import type { GenericOrganization, Provider } from '@app/src/types/organizations'
import type { AssessmentTemplate, RiskStatus, SolutionType } from '@app/src/types/resourceExplorer'

export enum ExpectationStatus {
  Requested = 'Requested',
  Accepted = 'Accepted',
  Declined = 'Declined',
  Completed = 'Completed',
  Delayed = 'Delayed',
}

export interface Expectation {
  id: number
  creatorOrganizationId: number
  creatorOrganization: GenericOrganization
  provider: Provider
  solutionType: SolutionType
  providerId: number
  title: string
  description: string
  dueAt: string
  createdAt: string
  status: ExpectationStatus
  assessmentTemplateId: number
  assessmentTemplate: AssessmentTemplate
  targetAssessmentLevel: number
  assessmentStartLevel?: number
}

export interface ExpectationHistoryEntry {
  expectationId: number
  creatorOrganizationId?: number
  createdAt: string
  status: ExpectationStatus
  comment: string
  creatorUser?: { name?: string }
  expectedAt?: string
  initiatorType: 'User' | 'Automation'
}

export interface ExpectationImprovement {
  id: number
  expectationId: number
  questionId: number
  committedOptions?: string[]
  createdAt: string
}

export interface ExpectationWithHistories extends Expectation {
  histories?: ExpectationHistoryEntry[]
  improvements?: ExpectationImprovement[]
  importantQuestions?: ImportantKpiEntry[]
}

export interface ExpectationAutomation {
  id: number
  createdAt: string
  updatedAt?: string
  deadlineYearsOffset?: number
  customDueDate?: string
  highestAllowedProviderRiskStatus?: RiskStatus
  targetAssessmentLevel: number
  assessmentTemplateId: number
  assessmentTemplate?: AssessmentTemplate
  importantQuestions?: ImportantKpiEntry[]
}

export interface ExpectationAutomationPayload {
  deadlineYearsOffset: number | null
  customDueDate?: string | null
  highestAllowedProviderRiskStatus: RiskStatus | null
  targetAssessmentLevel: number
  assessmentTemplateId: number
  applyToExisting?: boolean
  importantQuestions?: ImportantKpiEntry[]
}
